import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import ScrollToHash from './components/ScrollToHash';
import DevDrawer from './components/shirabe/DevDrawer/DevDrawer';
import Landing from './pages/Landing';
import Shirabe from './pages/Shirabe';
import ShirabeSample from './pages/ShirabeSample';
import NotFound from './pages/NotFound';

// パートナー版 (B 向け) の画面と PDF 生成は、必要なビルドにだけ入れる。
// - VITE_PARTNER=<slug>: そのパートナーの専用サイト (/ と /report)。専用ホストに出す。
// - 開発サーバー: 確認用に /partners/:slug でも開ける。
// - C 向けの本番ビルド: どちらも false になり、下の動的 import ごとバンドルから落ちる。
const PARTNER_SITE = Boolean(import.meta.env.VITE_PARTNER);
const PartnerLanding =
  import.meta.env.VITE_PARTNER || import.meta.env.DEV ? lazy(() => import('./pages/PartnerLanding')) : null;
const PartnerReport =
  import.meta.env.VITE_PARTNER || import.meta.env.DEV ? lazy(() => import('./pages/PartnerReport')) : null;

// 旧 URL (/shirabe, /shirabe/sample) からの移行。共有済みリンクの ?lat&lon を保ったまま転送する。
function LegacyRedirect({ to }: { to: string }) {
  const { search, hash } = useLocation();
  return <Navigate to={{ pathname: to, search, hash }} replace />;
}

// C 向け (一般の方) = / と /report。ルートを足したら infra/edge/spa-router.js も直す。
function ConsumerRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/report" element={<Shirabe />} />
      <Route path="/report/sample" element={<ShirabeSample />} />
      {PartnerLanding && <Route path="/partners/:slug" element={<PartnerLanding />} />}
      {PartnerReport && <Route path="/partners/:slug/report" element={<PartnerReport />} />}
      <Route path="/shirabe" element={<LegacyRedirect to="/report" />} />
      <Route path="/shirabe/sample" element={<LegacyRedirect to="/report/sample" />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

// パートナー版サイト = / (LP) と /report。ルートを足したら infra/edge/partner-router.js も直す。
function PartnerRoutes() {
  if (!PartnerLanding || !PartnerReport) return null;
  return (
    <Routes>
      <Route path="/" element={<PartnerLanding />} />
      <Route path="/report" element={<PartnerReport />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <>
      <ScrollToHash />
      <Suspense fallback={null}>{PARTNER_SITE ? <PartnerRoutes /> : <ConsumerRoutes />}</Suspense>
      <DevDrawer />
    </>
  );
}
